import { ReactComponent as HomepageBannerIcon } from './icons/homepage-banner.svg'
import AnimatedHeader from './AnimatedHeader'
import AnimatedLoading from './AnimatedLoading'

import styles from './HomepageBanner.module.css'

const HomepageBanner = () => {
  return (
    <div className="bg-maroon-400 relative">
      <HomepageBannerIcon className={styles.homepageBannerImage} />
      <div className="absolute bottom-7 left-6">
        <AnimatedHeader />
      </div>
      <div className="absolute top-10 md:top-14 right-10 md:right-64 w-full h-10">
        <AnimatedLoading />
      </div>
    </div>
  )
}

export default HomepageBanner
